export function replacePageInHistory(href: string): void {
    window.location.replace(href);
}
